<template>
  <div v-if="active" class="dropdown-content" :class="{ 'dropdown-above': showAbove }" ref="dropdownRef">
    <slot />
  </div>
</template>
<style>
.dropdown-content {
  display: flex;
  flex-direction: column;
  background-color: rgb(185, 217, 216);
  position: absolute;
  z-index: 5;
  top: 100%;
  min-width: 11rem;
  border-radius: 5%;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
}
.dropdown-content.dropdown-above {
  top: auto;
  bottom: 100%;
}
.dropdown-link {
  text-align: left;
  color: rgb(33, 37, 41);
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
}
.dropdown-link:hover {
  color: white;
  background-color: rgb(52, 148, 148);
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.svg-icon {
  max-height: 1.5rem;
  max-width: 1.5rem;
}
</style>
<script>
import { computed, inject, ref, nextTick, watch } from "vue";

export default {
  name: "SplitContent",
  inject: ["sharedState"],
  setup() {
    const sharedSplitState = inject("sharedState", null);
    const dropdownRef = ref(null);
    const showAbove = ref(false);

    const active = computed(() => {
      return sharedSplitState ? sharedSplitState.active : false;
    });

    // Check position when dropdown becomes active
    watch(active, async (newActive) => {
      if (newActive) {
        await nextTick();
        checkDropdownPosition();
      }
    });

    const checkDropdownPosition = () => {
      if (!dropdownRef.value) return;
      
      // Find the split-button container (parent element)
      const parentElement = dropdownRef.value.parentElement;
      if (!parentElement) return;
      
      const parentRect = parentElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const dropdownHeight = dropdownRef.value.scrollHeight || 240;

      // Calculate available space below the button
      const spaceBelow = viewportHeight - parentRect.bottom;
      
      // Show above if there's not enough space below
      showAbove.value = spaceBelow < dropdownHeight;
    };

    return {
      dropdownRef,
      showAbove,
      active
    };
  },
  updated() {
    // move element upward so entire element is visible within the viewport
    if (this.active && this.$el) {
      const rect = this.$el.getBoundingClientRect();
      if (rect.bottom > window.innerHeight) {
        const footer = document.getElementsByTagName('footer')[0];
        this.$el.style.bottom = `${footer.top - 10}px`; // `${window.innerHeight - rect.height - 10}px`;
      } else {
        this.$el.style.top = '';
      }
    }
  },
};
</script>
